import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Gizmo } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { tailwindMerge } from "@air/tailwind-variants";
import noop from "lodash/noop";
import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
const ReactDndDragWrapper = (param)=>{
    let { children, dragItem, swapItems, isDraggable = true, handleDrop = noop, className } = param;
    const ref = useRef(null);
    const [{ isDragging }, drag] = useDrag({
        item: {
            ...dragItem
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            })
    });
    const [, drop] = useDrop({
        accept: dragItem.type,
        drop (item) {
            handleDrop(item);
        },
        hover (item, monitor) {
            var _ref_current;
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = dragItem.index;
            if (dragIndex === hoverIndex) {
                return;
            }
            const hoverBoundingRect = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset && clientOffset.y - hoverBoundingRect.top || 0;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            swapItems(dragIndex, hoverIndex);
            item.index = hoverIndex;
        }
    });
    drag(drop(ref));
    const opacity = isDragging ? 0 : 1;
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        draggable: isDraggable,
        className: tailwindMerge("flex items-center", className),
        style: {
            opacity
        },
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                icon: Gizmo,
                disabled: !isDraggable,
                size: "small",
                appearance: "ghost",
                color: "grey",
                label: "Move"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "grow",
                children: children
            })
        ]
    });
};
export { ReactDndDragWrapper };
